import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BoxContainer from './StyledBoxContainer'
import EcommerceLink from './StyledEcommerceLink'
import ImageWrapper from './StyledImageWrapper'
import EcommerceImage from './StyledEcommerceImage'
import Discount from './StyledDiscount'
import TitleWrapper from './StyledTitleWrapper'
import Price from './StyledPrice'
import MoreButton from './StyledMoreButton'

class EcommerceBox extends Component {
  render () {
    const {
      box: {
        discount,
        guid,
        image,
        link,
        price,
        title
      }
    } = this.props

    const formattedPrice = (typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function')
      ? Math.floor(price).toLocaleString('cs-CZ')
      : Math.floor(price)

    return (
      <BoxContainer key={guid}>
        <EcommerceLink href={link}>
          <ImageWrapper>
            <EcommerceImage src={image} alt={title}/>
            {
              discount &&
              <Discount>
                -{ discount }%
              </Discount>
            }
          </ImageWrapper>
          <TitleWrapper>
            { title }
            <Price>
              { formattedPrice }&nbsp;Kč
            </Price>
            <MoreButton>
              Zjistěte více
            </MoreButton>
          </TitleWrapper>
        </EcommerceLink>
      </BoxContainer>
    )
  }
}

EcommerceBox.propTypes = {
  box: PropTypes.object.isRequired
}

export default EcommerceBox
